(function ($) {
  $(function () {
    //please add "vertical-card" class if you want hover again
    var $verticalCard = $('.demo');


    if ($verticalCard.length) {
      var verticalCard = (function () {
        function setVerticalCardElementsWidth($thisVerticalCard) {
          if ($(window).width() > 767) {
            $verticalCard.each(function () {
              var $thisVerticalCard = $(this);
              var $thisVerticalCardParent = $thisVerticalCard.parent();

              var verticalCardFrontWidth =
                $thisVerticalCardParent.width() -
                parseInt($thisVerticalCard.css('padding-left'), 10) -
                parseInt($thisVerticalCard.css('padding-left'), 10);

              $thisVerticalCard.find('.vertical-card__front').css({
                'flex-basis': verticalCardFrontWidth,
                'max-width': verticalCardFrontWidth,
                width: verticalCardFrontWidth,
              });


              var verticalCardAsideWidth =
                $thisVerticalCard.find('.vertical-card__front').outerWidth() +
                parseInt($thisVerticalCard.css('padding-left'), 10) +
                parseInt($thisVerticalCard.css('padding-right'), 10) +
                parseInt($thisVerticalCardParent.css('padding-left'), 10) +
                parseInt($thisVerticalCardParent.css('padding-right'), 10);

              // is card already open?
              if ($thisVerticalCard.find('.vertical-card__aside').width() > 0) {
                $thisVerticalCard.find('.vertical-card__aside').css({
                  'flex-basis': verticalCardAsideWidth,
                  'max-width': verticalCardAsideWidth,
                  'min-width': verticalCardAsideWidth,
                });
              }

              $thisVerticalCard.find('.vertical-card__content').css({
                'flex-basis': verticalCardAsideWidth,
                'max-width': verticalCardAsideWidth,
                'min-width': verticalCardAsideWidth,
              });
            });
          }
        }

        function handleVerticalCardMouseEnter() {
          if ($(window).width() > 767) {
            var $thisVerticalCard = $(this);
            var $thisVerticalCardParent = $thisVerticalCard.parent();
            var $thisVerticalCardFront = $thisVerticalCard.find(
              '.vertical-card__front'
            );

            var verticalCardAsideWidth =
              $thisVerticalCardFront.outerWidth() +
              parseInt($thisVerticalCard.css('padding-left'), 10) +
              parseInt($thisVerticalCard.css('padding-right'), 10) +
              parseInt($thisVerticalCardParent.css('padding-left'), 10) +
              parseInt($thisVerticalCardParent.css('padding-right'), 10);

            $thisVerticalCard
              .add($thisVerticalCard.parent())
              .css('z-index', '3');

            if ($thisVerticalCard.hasClass('vertical-card--reverse-animate')) {
              $thisVerticalCard.animate({
                left: verticalCardAsideWidth * -1,
              });
            }

            $thisVerticalCard.find('.vertical-card__aside').animate({
              'flex-basis': verticalCardAsideWidth,
              'max-width': verticalCardAsideWidth,
              width: verticalCardAsideWidth,
            });
          }
        }

        function handleVerticalCardMouseLeave() {
          if ($(window).width() > 767) {
            var $thisVerticalCard = $(this);

            if ($thisVerticalCard.hasClass('vertical-card--reverse-animate')) {
              $thisVerticalCard.animate(
                {
                  left: 0,
                },
                1
              );
            }

            $thisVerticalCard.find('.vertical-card__aside').animate(
              {
                'flex-basis': 0,
                'max-width': 0,
                width: 0,
              },
              1,
              function () {
                $thisVerticalCard
                  .add($thisVerticalCard.parent())
                  .css('z-index', 'auto');
              }
            );
          }
        }

        return {
          init: function () {
            setVerticalCardElementsWidth($(this));

            this.bindEvents();
          },
          bindEvents: function () {
            $verticalCard.on('mouseenter', handleVerticalCardMouseEnter);
            $verticalCard.on('mouseleave', handleVerticalCardMouseLeave);
          },
          setVerticalCardElementsWidth: setVerticalCardElementsWidth,
        };
      })();

      verticalCard.init();

      $(window).on('resize', verticalCard.setVerticalCardElementsWidth);

      $(window).on('load resize', function () {
        if ($(window).width() < 992 && $(window).width() > 767) {
          $verticalCard.eq(1).addClass('vertical-card--reverse-animate');
          $verticalCard.eq(2).removeClass('vertical-card--reverse-animate');
        } else {
          $verticalCard.eq(1).removeClass('vertical-card--reverse-animate');
          $verticalCard.eq(2).addClass('vertical-card--reverse-animate');
        }
      });
    }
  });
})(jQuery);
